import { BookingStateEnum } from '@mopla/data-models';

export function isBookingStatusCancelled(status: BookingStateEnum): boolean;
/**
 * @argument status
 * May contain values such as 'PRE_FINISHED' | 'DONE_BREAK' | 'DONE' which are
 * declared in `DataChange.type` - `libs\data-models\src\lib\types\scheduledLegs.ts`
 * They are should be revised and improved to save only strict typed values
 */
export function isBookingStatusCancelled(status: string): boolean;
export function isBookingStatusCancelled(
	status: BookingStateEnum | string
): boolean {
	return status.startsWith('CANCELLED');
}
